__turbopack_context__.v({
  "fadeIn": "styleConstants-module__NqnXWq__fadeIn",
  "fadeInText": "styleConstants-module__NqnXWq__fadeInText",
  "h1": "styleConstants-module__NqnXWq__h1",
  "h2": "styleConstants-module__NqnXWq__h2",
  "h3": "styleConstants-module__NqnXWq__h3",
  "sectionMargin": "styleConstants-module__NqnXWq__sectionMargin",
  "titleH": "styleConstants-module__NqnXWq__titleH",
});
